<template>
  <div class="custom-height">
    <div class="custom-label">{{ label }}</div>
    <money
      v-bind="config"
      :readonly="readonly"
      :disabled="disabled"
      :value="parseFloat(value)"
      @input="sendValue"
      @blur.native="blurValue"
      :maxlength="maxLength"
      class="money_input"
    ></money>

    <v-text-field
      ref="moneyValidate"
      id="display-none"
      :name="name"
      :value="valueM"
      :error-messages="errors.collect(name)"
      :data-vv-as="data_vv_as ? data_vv_as : label"
      v-validate="v_validate"
      data-vv-validate-on="blur"
      class="money_validate"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "PMoney",
  props: {
    name: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 20,
    },
    custom_precision: {
      type: Number,
      default: 2,
    },
    custom_preffix: {
      type: String,
      default: "R$",
    },
    customSuffix: {
      type: String,
      default: "",
    },
    value: {
      default: 0,
    },
    config: {
      type: Object,
      default: function () {
        return {
          decimal: ",",
          thousands: ".",
          prefix: this.custom_preffix ? this.custom_preffix + " " : "",
          suffix: this.customSuffix + "",
          precision: this.custom_precision,
          masked: false,
        };
      },
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    v_validate: {
      type: String,
      default: "",
    },
    data_vv_as: {
      type: String,
    },
  },
  data: () => ({
    teste: true,
    valueM: 0,
  }),
  methods: {
    blurValue(val) {
      // Emitir o blur para pegar a validação
      this.$refs["moneyValidate"].$emit("blur");
    },
    sendValue(val) {
      this.valueM = parseFloat(val);
      // Converte o valor que vem com mascara, para um valor float
      this.$emit("input", this.valueM);
    },
  },
};
</script>

<style>
.money_input {
  outline-width: 0;
  height: 30px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  border-bottom: 1px solid #949494;
  width: 100%;
}

.custom-label {
  font-family: Roboto, sans-serif;
  font-size: 12px;
}

.custom-height {
  height: 66px;
  display: flex;
  flex-direction: column;
}

.money_validate {
  padding: 0;
  margin: 0;
  top: -1px;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/PMoney.vue